import React from "react";
import Hero from "../components/Hero";
import Contact from "../components/Contact";
import Vacancies from "../components/Vacancies";
import Maps from "../components/Maps";
import TrafficArbitrage from "../components/TrafficArbitrage";
import StrategyBenefits from "../components/StrategyBenefits";
import PricingPlans from "../components/PricingPlans";

function Home() {
  return (
    <div className="home">
      <Hero />
      <Maps />
      <Vacancies />
      <TrafficArbitrage />
      <StrategyBenefits />
      <PricingPlans />
      <Contact />
    </div>
  );
}

export default Home;
